export const USAGE_TRACKING_NAMESPACE = 'Deal Intel Decorators';
export const USAGE_TRACKING_EVENT = {
  MEETING_FOLLOW_UP_INTERACTED: 'Meeting Follow Up Interacted'
};
export const USAGE_TRACKING_ACTION = {
  MEETING_FOLLOW_UP_POPOVER_OPENED: 'Meeting Follow Up Popover Opened',
  MEETING_FOLLOW_UP_LINK_CLICKED: 'Meeting Follow Up Link Clicked'
};